<div class="input-group mb-2 d-block">
  <label class="font-weight-bold mb-2 d-block mt-0">{{title | translate}}</label>
  <input (change)="select($event)" [id]="id" class="form-control text-picker" type="text">
</div>
